const initState = {
  loading: false,
  data: "",
  error: "",
};

export default initState;
